export default __webpack_public_path__ + "static/media/sanmar11.25a7ecb5.jpg";